(function () {
  'use strict';

  var progress = document.createElement('div');
  progress.className = 'pv-scroll-progress';
  progress.setAttribute('aria-hidden', 'true');
  document.body.appendChild(progress);

  var scheduled = false;
  function updateProgress() {
    var range = document.documentElement.scrollHeight - window.innerHeight;
    var amount = range > 0 ? Math.min(1, Math.max(0, window.scrollY / range)) : 0;
    progress.style.transform = 'scaleX(' + amount + ')';
    scheduled = false;
  }
  window.addEventListener('scroll', function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateProgress);
  }, { passive: true });
  updateProgress();

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var items = Array.from(document.querySelectorAll(
    '.pv-section:not(.pv-hero), .pv-how, .pv-colls, .pv-trust, .pv-pop, .pv-why, .pv-faq, .pv-seo-hub, .pvc-seo-content'
  ));
  if (!items.length) return;

  document.documentElement.classList.add('pv-motion-ready');
  items.forEach(function (item) { item.classList.add('pv-motion-item'); });

  if (!('IntersectionObserver' in window)) {
    items.forEach(function (item) { item.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.06, rootMargin: '0px 0px -32px 0px' });

  items.forEach(function (item) { observer.observe(item); });
})();
